import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Grid, Row} from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from "react-router-dom";
import { setMessage } from "../../../../redux/actions/status";
import DCIForm from './DCIForm';

class DCIResult extends React.Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            vSubstanceDCI: '',
            vSubstanceDCI1: '',
            vDCI: '',
            nomSubstance: '',
            result: {
                status:null,
                data:"Après avoir selectionner vos données appuyer sur le button ci-dessous pour lancer l&apos;analyse "
            }
        }
    }
    onChangeSub = substance => {
        this.setState({ vDCI: substance.label });
        if(substance.substanceContreIndiquees1== undefined){
            substance.substanceContreIndiquees1 =''
        }
        if(substance.substanceContreIndiquees1.includes(',')){
            this.setState({
                vSubstanceDCI1: substance.substanceContreIndiquees1.split(","),
                vDCI: substance.label.toUpperCase()
            });
        }
        else{
            this.setState({
                vSubstanceDCI1: substance.substanceContreIndiquees1.toUpperCase(),
                vDCI: substance.label.toUpperCase()
            });
        }
    }

    onChangeSubstance = substance => {
        this.setState({ nomSubstance: substance.label });
        
        if(substance.substanceContreIndiquees== undefined){
            substance.substanceContreIndiquees =''
        }
        if(substance.substanceContreIndiquees.includes(',')){
            this.setState({
                vSubstanceDCI: substance.substanceContreIndiquees.split(","),
                nomSubstance: substance.label.toUpperCase()
            });
        }
        else{
            this.setState({
                vSubstanceDCI: substance.substanceContreIndiquees.toUpperCase(),
                nomSubstance: substance.label.toUpperCase()
            });
        }
        }
    onSubmit(event) {
        event.preventDefault();
        if(this.state.nomSubstance==''||this.state.vDCI == ''){
            this.setState({result: {status:0, data:"VEUILLEZ SELECTIONNER LES DONNEES A ANALYSER !"}});
            this.props.setMessage({ message: "Champ vide !", status: "danger" });
        }
        else if(this.state.vSubstanceDCI.indexOf(this.state.vDCI.toLowerCase()) != -1 || this.state.vSubstanceDCI1.indexOf(this.state.nomSubstance.toLowerCase()) != -1){
            this.setState({result: {status:1, data:"< "+this.state.nomSubstance+" > "+" est contre-indiqué en association avec : "+"< "+this.state.vDCI.toUpperCase()+" >"}});
            this.props.setMessage({ message: "< "+this.state.nomSubstance+" > "+" est contre-indiqué en association avec: "+"< "+this.state.vDCI.toUpperCase()+" >", status: "warning" });
        } else{
            this.setState({result: {status:-1, data:"< "+this.state.nomSubstance+" > "+" n&apos;est pas contre-indiqué en association avec : "+"< "+this.state.vDCI.toUpperCase()+" >"}});
            this.props.setMessage({ message: "< "+this.state.nomSubstance+" > "+" n&apos;est pas contre-indiqué en association avec : "+"< "+this.state.vDCI.toUpperCase()+" >", status: "success" });
        }  
       
    }
    
    render() {
        return (
            <div className="main-content" >
                <Grid fluid>
                <Row>
                    <Col md={12} style={{ marginBottom: "16px" }}>
                        <Link to="/app/analyse/analyses">
                            <Button bsStyle="default" fill bsSize="lg">
                                Retour
                            </Button>
                        </Link>
                    </Col>
                </Row>
                    <Col sm={12}>
                        <form onSubmit={this.onSubmit}>
                            <DCIForm
                                onChangeSubstance = {this.onChangeSubstance}
                                onChangeSub = {this.onChangeSub}
                                result={this.state.result}
                            />
                        </form>
                    </Col>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
        substance: state.substances.substance,        
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setMessage: (message) => {
            dispatch(setMessage(message));
        }
    }
};
  
DCIResult.propTypes = {
    match: PropTypes.object,
    message: PropTypes.object,
    loading: PropTypes.bool,
    setMessage: PropTypes.func,
    Substance: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(DCIResult);